import { API, VM } from '..';

export const mapTrainingProgramInfoFromApiToVm = (
    trainingProgramInfo: API.TrainingProgramInfo
): VM.TrainingProgramInfo => ({
    id: trainingProgramInfo.id,
    name: trainingProgramInfo.name,
    deviceType: mapTrainingProgramInfoDeviceTypeFromApiToVm(trainingProgramInfo.deviceType),
    stages: trainingProgramInfo.stages.map(mapTrainingProgramInfoStageFromApiToVm),
    applicableLocations: trainingProgramInfo.applicableLocations.map(
        mapTrainingProgramInfoApplicableLocationFromApiToVm
    ),
});

const mapTrainingProgramInfoStageFromApiToVm = (stage: API.TrainingProgramInfoStage): VM.TrainingProgramInfoStage => ({
    id: stage.id,
    name: stage.name,
});

const mapTrainingProgramInfoDeviceTypeFromApiToVm = (
    deviceType: API.TrainingProgramInfoDeviceType
): VM.TrainingProgramInfoDeviceType => ({
    id: deviceType.id,
    name: deviceType.name,
    permissionGroupId: deviceType.permissionGroupId,
    permissionGroupName: deviceType.permissionGroupName,
});

const mapTrainingProgramInfoApplicableLocationFromApiToVm = (
    location: API.TrainingProgramInfoApplicableLocations
): string => location.locationId;
